import axios from "axios";

export default function getUnprocessMLRoleNotification({ role_id }) {
  return new Promise((resolve, reject) => {
    axios
      .post("/distributor/admin/api/v1/master-list/notification-count-role", {
        role_id,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
